import { useSelector } from 'react-redux';
import { IAppState } from 'config/redux/reducers';

import isPaymentV2Enabled from '../helpers/isPaymentV2Enabled';

const usePaymentV2Enabled = () => {
  const appState = useSelector((state: IAppState) => state);

  const isWebPaymentArchitectureV2Enabled = isPaymentV2Enabled(appState);

  return { isWebPaymentArchitectureV2Enabled };
};

export default usePaymentV2Enabled;
